import { isValidPhoneNumber } from "libphonenumber-js";

/**
 * Validates a US phone number string
 * Handles both 10-digit (without country code) and 11-digit (with US country code +1) formats
 * @param phoneNumber - The phone number string to validate
 * @returns true if valid, false otherwise
 */
export const validateUsPhoneNumberInput = (phoneNumber?: string): boolean => {
  if (!phoneNumber || phoneNumber.length === 0) {
    return true; // Empty/undefined is considered valid (optional field)
  }

  const cleanedData = phoneNumber.replace(/\D/g, "");

  // Handle both 10-digit (without country code) and 11-digit (with US country code +1)
  if (cleanedData.length === 10) {
    return isValidPhoneNumber(cleanedData, "US");
  } else if (cleanedData.length === 11 && cleanedData.startsWith("1")) {
    // Remove the leading "1" and validate the remaining 10 digits
    const phoneWithoutCountryCode = cleanedData.substring(1);
    return isValidPhoneNumber(phoneWithoutCountryCode, "US");
  }

  return false;
};
